module.exports = __webpack_public_path__ + "static/fipcpurplefloralrab1-30ec2ca8504ff9884477d9ddf824196f.jpeg";